export default __webpack_public_path__ + "static/media/5A-logo.9cee1982.png";